import { Search, X } from "lucide-react";

import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

type SearchBarProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  ariaLabel?: string;
  className?: string;
};

/** Centered, pill-shaped search input with a clear (✕) button. */
const SearchBar = ({
  value,
  onChange,
  placeholder = "Search",
  ariaLabel = "Search",
  className,
}: SearchBarProps) => (
  <div className={cn("flex justify-center", className)}>
    <div className="relative flex w-full items-center rounded-full bg-gray-200 sm:w-1/2 lg:w-1/3">
      <Input
        type="text"
        placeholder={placeholder}
        aria-label={ariaLabel}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        className="rounded-full bg-transparent p-5 pr-16 shadow-none placeholder:text-gray-400 focus-within:bg-gray-100 focus:border-gray-400 focus-visible:ring-transparent"
      />
      {value && (
        <button
          type="button"
          onClick={() => onChange("")}
          aria-label="Clear search"
          data-testid="clear-search-button"
          className="absolute right-10 mr-1 text-gray-600 hover:text-black"
        >
          <X className="size-4" />
        </button>
      )}
      <Search className="pointer-events-none absolute right-5 size-4 text-gray-600" />
    </div>
  </div>
);

export default SearchBar;
